import styled from '@emotion/styled';

export const LatestPostsLabel = styled.p`
  padding: 0 0 4rem 0;
  font-size: 1.5rem;
  text-align: center;
`;
